import { adapterFactory as baseAdapterFactory } from 'calendar-utils/date-adapters/moment';
export function adapterFactory(moment) {
    return Object.assign(Object.assign({}, baseAdapterFactory(moment)), { addWeeks(date, amount) {
            return moment(date).add(amount, 'weeks').toDate();
        },
        addMonths(date, amount) {
            return moment(date).add(amount, 'months').toDate();
        },
        subDays(date, amount) {
            return moment(date).subtract(amount, 'days').toDate();
        },
        subWeeks(date, amount) {
            return moment(date).subtract(amount, 'weeks').toDate();
        },
        subMonths(date, amount) {
            return moment(date).subtract(amount, 'months').toDate();
        },
        getISOWeek(date) {
            return moment(date).isoWeek();
        },
        setDate(date, dayOfMonth) {
            return moment(date).date(dayOfMonth).toDate();
        },
        setMonth(date, month) {
            return moment(date).month(month).toDate();
        },
        setYear(date, year) {
            return moment(date).year(year).toDate();
        },
        getDate(date) {
            return moment(date).date();
        },
        getYear(date) {
            return moment(date).year();
        } });
}
